<!-- Life At Kalpita Hero Banner -->
<div class="life-kalpita-bg">
  <section class="life-kalpita-section container py-5">
    <div class="glass-panel-container life-glass">
      <div class="row align-items-center">
        <!-- Left Text Section -->
        <div class="col-lg-3 col-md-4 text-left life-text">
          <h2 class="life-heading">Life At</h2>
          <h1 class="life-subheading">KALPITA</h1>
        </div>

        <!-- Right Image Section -->
        <div class="col-lg-9 col-md-8 text-center">
          <img src="../../../../assets/gallery-page/life-at-kalpita/life-at-kalpita-bannerimage.png"
            alt="Life at Kalpita" class="img-fluid life-hero-image">
        </div>
      </div>
    </div>
  </section>
</div>

<!-- Shorts Section (Updated with Home Page Gallery Logic) -->
<div class="life-shorts-section">
  <div class="container">
    <h2 class="shorts-heading">Quick Bites of Fun</h2>

    <div class="shorts-gallery">
      <!-- Added trackBy for smooth animation -->
      <div class="shorts-container">
        <ng-container *ngFor="let short of currentSlideShorts; let i = index; trackBy: trackByVideoId">
          <div class="shorts-item" 
               [ngClass]="getShortsVideoSizeClass(i)" 
               (click)="onShortsThumbnailClick(i)">
            
            <div class="shorts-wrapper">
              <div class="shorts-thumbnail">
                <img [src]="short.thumbnail" [alt]="short.title" loading="lazy">
                <div class="shorts-overlay"></div>
                <button class="play-button" aria-label="Play Short">
                  <img src="../../../assets/gallery-page/life-at-kalpita/btn.png" alt="Play" class="play-icon">
                </button>
              </div>
            </div>
            <div class="shorts-title"><span>{{ short.title }}</span></div>
            
          </div>
        </ng-container>
      </div>

      <!-- Pagination Dots -->
      <div class="carousel-dots">
        <span *ngFor="let dot of [].constructor(shortsDotCount); let di = index" 
              class="dot"
              [class.active]="di === getShortsActiveDot()" 
              (click)="onShortsDotClick(di)">
        </span>
      </div>
    </div>
  </div>
</div>

<!-- ================== VIDEOS SECTION ================== -->
<section class="life-videos-section py-5">
  <div class="container">
    <h2 class="videos-heading text-center mb-5">Videos</h2>

    <div class="d-flex align-items-center position-relative">
      <!-- Left Arrow -->
      <button *ngIf="showTrainingCarousel" class="carousel-arrow-btn left" (click)="trainingSlide('prev')"
        [disabled]="trainingCurrentCenterIndex === 0">
        <i class="bi bi-chevron-left"></i>
      </button>

      <!-- Videos Grid Wrapper -->
      <div class="videos-grid-wrapper">
        <!-- First Row with left gap -->
        <div class="videos-row first-row">
          <div class="video-card"
            *ngFor="let video of (showTrainingCarousel ? trainingSlideVideos : trainingVideos.slice(0,4))"
            (click)="openVideoModal(video)">
            <div class="video-thumbnail-wrapper">
              <img [src]="video.thumbnail" [alt]="video.title" class="video-thumbnail" />
              <div class="play-button">
                <svg width="80" height="80" viewBox="0 0 80 80" class="play-icon">
                  <circle cx="40" cy="40" r="38" fill="rgba(255,255,255,0.9)" stroke="rgba(0,0,0,0.1)"
                    stroke-width="2" />
                  <polygon points="32,25 32,55 55,40" fill="#016096" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <!-- Second Row without gap -->
        <div class="videos-row second-row">
          <div class="video-card"
            *ngFor="let video of (showTrainingCarousel ? trainingSlideVideos.slice(4,8) : trainingVideos.slice(4,8))"
            (click)="openVideoModal(video)">
            <div class="video-thumbnail-wrapper">
              <img [src]="video.thumbnail" [alt]="video.title" class="video-thumbnail" />
              <div class="play-button">
                <svg width="80" height="80" viewBox="0 0 80 80" class="play-icon">
                  <circle cx="40" cy="40" r="38" fill="rgba(255,255,255,0.9)" stroke="rgba(0,0,0,0.1)"
                    stroke-width="2" />
                  <polygon points="32,25 32,55 55,40" fill="#016096" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Arrow -->
      <button *ngIf="showTrainingCarousel" class="carousel-arrow-btn right" (click)="trainingSlide('next')"
        [disabled]="trainingCurrentCenterIndex + trainingVisibleCount >= trainingVideos.length">
        <i class="bi bi-chevron-right"></i>
      </button>

    </div>

    <!-- Carousel Dots -->
    <div class="carousel-dots mt-5" *ngIf="showTrainingCarousel">
      <span class="dot" *ngFor="let _ of createArray(trainingDotCount); let i = index"
        [class.active]="trainingCurrentCenterIndex === i * trainingVisibleCount" (click)="onTrainingDotClick(i)">
      </span>
    </div>
  </div>
</section>

<!-- Images Section -->
<div class="images-section py-5">
  <div class="container">
    <h2 class="section-title heading-two">Images</h2>
    <div class="d-flex align-items-center position-relative">
      <!-- Left Arrow -->
      <button *ngIf="showGalleryCarousel" class="carousel-arrow-btn left" (click)="gallerySlide('prev')"
        [disabled]="galleryCurrentCenterIndex === 0">
        <i class="bi bi-chevron-left"></i>
      </button>
      <!-- Gallery Carousel -->
      <div class="gallery-carousel-container">
        <div class="gallery-card" *ngFor="let img of gallerySlideImages">
          <img [src]="img.src" [alt]="img.alt" class="gallery-img" />
          <div class="gallery-card-caption">
            {{ img.caption }}
          </div>
        </div>
      </div>
      <!-- Right Arrow -->
      <button *ngIf="showGalleryCarousel" class="carousel-arrow-btn right" (click)="gallerySlide('next')"
        [disabled]="galleryCurrentCenterIndex + galleryVisibleCount >= galleryImages.length">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>

    <!-- Carousel Dots -->
    <div class="carousel-dots" *ngIf="showGalleryCarousel">
      <span *ngFor="let _ of createArray(galleryDotCount); let i = index" class="dot"
        [class.active]="galleryCurrentCenterIndex === i * galleryVisibleCount" (click)="onGalleryDotClick(i)">
      </span>
    </div>
    <!-- Modal, if used -->
    <div class="image-modal-overlay" *ngIf="showImageModal" (click)="closeImageModal()">
      <div class="image-modal-container" (click)="$event.stopPropagation()">
        <button class="modal-close-btn" (click)="closeImageModal()">
          <i class="bi bi-x"></i>
        </button>
        <img *ngIf="currentModalImage" [src]="currentModalImage.src" [alt]="currentModalImage.alt"
          class="modal-image" />
        <div class="modal-image-caption" *ngIf="currentModalImage">
          {{ currentModalImage.caption }}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Video Modal -->
<div class="video-modal-overlay" *ngIf="showVideoModal" (click)="closeVideoModal()">
  <div class="video-modal-container" (click)="$event.stopPropagation()">
    <button class="modal-close-btn" (click)="closeVideoModal()">
      <i class="bi bi-x"></i>
    </button>
    <div class="modal-video-wrapper">
      <iframe *ngIf="currentModalVideo && currentModalVideo.safeUrl" [src]="currentModalVideo.safeUrl"
        class="modal-video-iframe" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </div>
    <div class="modal-video-title" *ngIf="currentModalVideo">
      {{ currentModalVideo.title }}
    </div>
  </div>
</div>

<!-- Shorts Modal (Updated) -->
<div class="shorts-modal-overlay" *ngIf="showShortsModal" (click)="closeShortsModal()">
  <div class="shorts-modal-container" (click)="$event.stopPropagation()">
    <button class="modal-close-btn" (click)="closeShortsModal()">
      <i class="bi bi-x"></i>
    </button>
    <div class="modal-shorts-wrapper">
      <iframe *ngIf="currentShortsModalVideo && currentShortsModalVideo.safeUrl" [src]="currentShortsModalVideo.safeUrl"
        class="modal-shorts-iframe" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </div>
    <div class="modal-shorts-title" *ngIf="currentShortsModalVideo">{{ currentShortsModalVideo.title }}</div>
  </div>
</div>